const STARTING_BALANCE = "STARTING_BALANCE";

const computeUnitValue = (ibwsts) => {
  if (!ibwsts || ibwsts.length === 0) return null;
  const totalQuantity = ibwsts.reduce((sum, ib) => sum + ib.quantity, 0);
  if (totalQuantity === 0) return null;
  const totalValue = ibwsts.reduce(
    (sum, ib) => sum + ib.quantity * (ib.inventoryBatch?.costPerUnit ?? 0),
    0
  );
  return totalValue / totalQuantity;
};

export const mapTransactionsWithBalance = (rows) => {
  let balance = null;

  return rows.map((row, index) => {
    if (row.transactionableType === STARTING_BALANCE) {
      balance = row.quantity;
      return {
        id: "starting-balance",
        transactionableType: STARTING_BALANCE,
        quantityIn: row.quantity,
        quantityOut: 0,
        balance,
        unitValue: null,
      };
    }

    const quantityIn = row.quantity > 0 ? row.quantity : 0;
    const quantityOut = row.quantity < 0 ? Math.abs(row.quantity) : 0;
    if (balance !== null) balance += row.quantity;

    return {
      ...row,
      id: row.id ?? `row-${index}`,
      quantityIn,
      quantityOut,
      balance,
      unitValue: computeUnitValue(row.inventoryBatchWarehouseStockTransactions),
    };
  });
};
